import React from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../Redux/Actions"
import colors from "../../Constants/colors"
import { isCourseBuilderEndOfCourse } from "../../Utils/workshopNavigation"

const PYPPartDesktopFooterContent = ({
  decrementPartId,
  history,
  savePYP,
  currentPartComplete,
  incrementPartId,
  fetchingPartData,
  isFinishCta
}) => {
  const nextHandler = async (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (fetchingPartData) {
      return
    } // Nothing happens if data is still being fetched

    if (currentPartComplete) {
      await savePYP()
      await incrementPartId(history)
    }
  }

  const prevHandler = async (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!fetchingPartData) {
      await savePYP()
      decrementPartId(history)
    }
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        position: "sticky",
        // marginTop: "2px",
        bottom: "0px"
      }}
    >
      <button
        id="pyp-previous-btn"
        type="button"
        style={{
          ...styles.mobilePrevButton,
          opacity: !fetchingPartData ? 1 : 0.4
        }}
        onClick={prevHandler}
      >
        Previous
      </button>
      <button
        id="pyp-next-btn"
        className="partBtnNext"
        type="button"
        style={{
          ...styles.mobileNextButton,
          opacity: !fetchingPartData && currentPartComplete ? 1 : 0.4
        }}
        onClick={nextHandler}
      >
        {isFinishCta ? "Finish" : "Next"}
      </button>
    </div>
  )
}

const styles = {
  mobilePrevButton: {
    width: "50%",
    height: "8.5vh",
    fontSize: "17px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colors.white,
    fontFamily: "Lato-Regular",
    backgroundColor: colors.blueyGrey,
    border: "none"
  },
  mobileNextButton: {
    width: "50%",
    fontFamily: "Lato-Regular",
    fontSize: "17px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "8.5vh",
    color: colors.white,
    backgroundColor: colors.fadedRed,
    border: "none"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    currentPartComplete: state.pyp.currentPartComplete,
    fetchingPartData: state.pyp.fetchingPartData || state.pyp.partIsLoading,
    isFinishCta: isCourseBuilderEndOfCourse(state.pyp)
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PYPPartDesktopFooterContent)
)
